import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react";
import { ChevronIcon } from "@/assets/icons";
import type { ReactNode } from "react";

interface AccordionProps {
  title: string;
  children: ReactNode;
  isOpen?: boolean;
  onToggle?: (open: boolean) => void;
  defaultOpen?: boolean;
  className?: string;
}

export default function Accordion({
  title,
  children,
  isOpen,
  onToggle,
  defaultOpen = false,
  className = "",
}: AccordionProps) {
  const isControlled = isOpen !== undefined && onToggle !== undefined;

  if (isControlled) {
    return (
      <div
        className={`border border-gray-200 rounded-lg overflow-hidden bg-white shadow-sm ${className}`}
      >
        <button
          type="button"
          onClick={() => onToggle(!isOpen)}
          className="flex w-full items-center justify-between px-4 py-5 text-left text-lg font-semibold text-gray-900 bg-white hover:bg-gray-50 focus:outline-none transition-colors duration-150 cursor-pointer"
        >
          <span>{title}</span>
          <ChevronIcon size={14} direction={isOpen ? "up" : "down"} />
        </button>
        {isOpen && (
          <div className="px-4 pb-4 pt-0 text-sm text-gray-700">{children}</div>
        )}
      </div>
    );
  }

  return (
    <Disclosure defaultOpen={defaultOpen}>
      {({ open }) => (
        <div
          className={`border border-gray-200 rounded-lg overflow-hidden bg-white shadow-sm ${className}`}
        >
          <DisclosureButton className="flex w-full items-center justify-between px-4 py-5 text-left text-lg font-semibold text-gray-900 bg-white hover:bg-gray-50 focus:outline-none transition-colors duration-150 cursor-pointer">
            <span>{title}</span>
            <ChevronIcon size={14} direction={open ? "up" : "down"} />
          </DisclosureButton>
          <DisclosurePanel className="px-4 pb-4 pt-0 text-sm text-gray-700">
            {children}
          </DisclosurePanel>
        </div>
      )}
    </Disclosure>
  );
}
